import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import classnames from 'classnames';
import {
  cropSeasonYearOptions,
  getCurrentCropYear,
} from '../../../utilities/UtilityFunctions';
import './financialYearSelector.less';

export const FinancialYearSelector = (props) => {
  const {
    salesYear,
    commonMessages,
    updateSalesYear,
    getSeasonCropYearFromConfig,
  } = props;
  const [getYearsDropDownList, setYearsDropDownList] = useState([]);
  const currentCropYear = getCurrentCropYear();

  const yearDropDownChange = (key) => {
    updateSalesYear(key);
    sessionStorage.setItem('CropYearSelected', key);
  };

  useEffect(() => {
    sessionStorage.setItem('CropYearSelected', currentCropYear);
    getSeasonCropYearFromConfig((year) => {
      yearDropDownChange(year);
      if (!cropSeasonYearOptions.includes(year)) {
        const yearOptions = [year, ...cropSeasonYearOptions];
        setYearOptionsDropDownList(yearOptions);
      }
    });
    setYearOptionsDropDownList(cropSeasonYearOptions);
  }, []);

  const setYearOptionsDropDownList = (yearOptions) => {
    const yearsDropDown = yearOptions.map((year) => ({
      key: year,
      label: year,
    }));
    setYearsDropDownList(yearsDropDown);
  };

  return (
    <Dropdown
      className="financial-year-selector"
      overlay={
        <Menu>
          {getYearsDropDownList.map((yearSelected) => {
            return (
              <Menu.Item
                onClick={() => yearDropDownChange(yearSelected.key)}
                key={yearSelected.key}
              >
                {yearSelected.label}
              </Menu.Item>
            );
          })}
        </Menu>
      }
    >
      <span>
        <span className={salesYear < currentCropYear ? 'warning-info' : ''}>
          {commonMessages.financial_year_selection_label}
        </span>
        <Button
          className={classnames(
            salesYear < currentCropYear ? 'warning-info' : '',
            'dropdown-menu-button'
          )}
        >
          {
            (
              getYearsDropDownList.find(
                (yearSelected) => yearSelected.key === salesYear
              ) || {}
            ).label
          }
        </Button>
      </span>
    </Dropdown>
  );
};
